import React, { memo } from 'react'
import { Avatar, Box, Stack, TableRow } from '@mui/material'
import { faEye, faEyeSlash, faPen } from '@fortawesome/pro-light-svg-icons'

import DashboardCard from '../shared/DashboardCard/DashboardCard'
import DataTable from '../shared/DataTable/DataTable'
import TableCellData from '../shared/DataTable/TableCellData'
import CustomButton from '../shared/buttons/CustomButton'
import FaIcon from '../shared/FaIcon/FaIcon'
import StatusLabel from '../shared/StatusLabel/StatusLabel'
import { formatToLongDate } from '../../util/date.helpers'
import {
  buildStatusLabelColor,
  QUEST_STATUS_OPTIONS
} from '../../util/quest.helpers'
import { CSS_FLEX_ALIGNED } from '../../styles/common'
import { t } from 'i18next'
import { formatTicks } from '../../util/string.helpers'

const QuestsData = ({
  t,
  tableHeaders,
  onEdit,
  onActivate,
  tokenProfile: { symbol },
  questListProfile: { filteredData, loading },
  selected,
  isListUpdate
}) => {
  const tableRows = filteredData.map((item, index) => (
    <DataTableRow
      key={index}
      {...item}
      symbol={symbol}
      disabled={isListUpdate && item.id === selected?.id}
      onEdit={() => onEdit(item)}
      onActivate={() => onActivate(item, true)}
      onDeactivate={() => onActivate(item, false)}
      t={t}
    />
  ))
  return (
    <DashboardCard>
      <DataTable
        headers={tableHeaders}
        data={tableRows}
        sx={{
          whiteSpace: {
            xs: 'nowrap',
            sm: 'unset'
          }
        }}
        noRecordsMessage={
          loading
            ? t('quest.loading-quests')
            : !tableRows.length && t('quest.no-quests-found')
        }
      />
    </DashboardCard>
  )
}

export default memo(QuestsData)

const DataTableRow = ({
  title,
  mediaUrl,
  amount,
  symbol,
  status,
  startDate,
  endDate,
  onEdit,
  onActivate,
  onDeactivate,
  disabled
}) => {
  const isActivated = status === QUEST_STATUS_OPTIONS.ACTIVE
  return (
    <TableRow>
      <TableCellData>
        <Box sx={CSS_FLEX_ALIGNED}>
          <Avatar
            src={mediaUrl}
            sx={{ width: 50, height: 50, borderRadius: '7px' }}
            variant='square'
          />
          <Box sx={{ color: '', fontWeight: 500, pl: 2 }}>{title}</Box>
        </Box>
      </TableCellData>
      <TableCellData>
        {formatTicks(amount)} {symbol}
      </TableCellData>
      <TableCellData>{formatToLongDate(startDate)}</TableCellData>
      <TableCellData>{formatToLongDate(endDate)}</TableCellData>
      <TableCellData noTag>
        <StatusLabel
          label={t(`quest.quest-status-types.${status}`)}
          color={buildStatusLabelColor(status)}
          size={10}
        />
      </TableCellData>
      <TableCellData>
        <Stack
          spacing={1}
          direction={{ xs: 'column', sm: 'row' }}
          sx={{ alignItems: 'center', justifyContent: 'center' }}
        >
          <CustomButton
            fullWidth={false}
            label={<FaIcon icon={faPen} size='lg' />}
            onClick={onEdit}
          />
          {isActivated ? (
            <CustomButton
              fullWidth={false}
              label={<FaIcon icon={faEyeSlash} size='lg' />}
              onClick={onDeactivate}
              disabled={disabled}
              color='error'
            />
          ) : (
            <CustomButton
              fullWidth={false}
              label={<FaIcon icon={faEye} size='lg' />}
              onClick={onActivate}
              disabled={disabled}
              color='success'
            />
          )}
        </Stack>
      </TableCellData>
    </TableRow>
  )
}
